import { Action, createReducer, on } from '@ngrx/store';
import {
    resetState,
    fetchSingleRecordSuccess
} from './payment-arrangement.action';

import { PaymentArrangement } from './payment-arrangement.model';
import { PaymentType } from '../PaymentType/payment-type.model';

export interface PaymentArrangementRecordsState {
    listData: any[];
    paymentTypes: PaymentType[];
    total: number;
    singleData: PaymentArrangement;
    loading: boolean;
    error: any;
}

export const initialState: PaymentArrangementRecordsState = {
    listData: [],
    paymentTypes: [],
    total: 0,
    singleData: null,
    loading: false,
    error: null,
};


export const PaymentArrangementRecordReducer = createReducer(

    initialState,

    // Single record
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    //Reset State
    on(resetState, () => initialState)  // Reset action handler
);